/** Печатные документы: sales. ky/en/uz — с теми же ключами (проверяется типом). */
import type { Shape } from "./shape";

export const ru = {
  // Чек и пречек
  receipt: "Чек",
  waiter: "Официант",
  tip: "Чаевые",
  change: "Сдача",
  refund: "Возврат",
  netPaid: "Итого оплачено",
  // Общие колонки
  count: "Количество",
  dateTime: "Дата и время",
  indicator: "Показатель",
  value: "Значение",
  method: "Способ оплаты",
  share: "Доля",
  operation: "Операция",
  kind: "Тип",
  tags: "Теги",
  manager: "Управляющий",
  summary: "Итоги",
  byMethod: "По способам оплаты",
  // Заказы
  ordersTitle: "Журнал заказов",
  // Касса
  opNo: "Операция № {{n}}",
  basis: "Основание",
  handedIn: "Сдал",
  received: "Получил",
  issued: "Выдал",
  incoming: "Приход",
  outgoing: "Расход",
  incomingOrder: "Приходный кассовый ордер",
  outgoingOrder: "Расходный кассовый ордер",
  shiftOpsTitle: "Кассовые операции смены",
  slip80: "Квитанция (80 мм)",
  cashOrderA4: "Кассовый ордер (A4)",
  // Финансы и аналитика
  financeTitle: "Финансовый отчёт",
  pnl: "Прибыли и убытки",
  foodCostPct: "Food cost, %",
  laborCostPct: "ФОТ к выручке, %",
  marginPct: "Маржа, %",
  supplierCredit: "Закупки в долг у поставщиков",
  creditSales: "Продажи в долг",
  debtRepayments: "Погашения долгов",
  expenseCategory: "Статья расходов",
  purchasedSum: "Закуплено на сумму",
  writtenOffSum: "Списано на сумму",
  writeoffsTitle: "Списания",
  cancelledOrders: "Отменено заказов",
  voidedLines: "Удалено позиций",
  // Доставка
  courierSlip: "Маршрутный лист",
  deliveryFee: "Доставка",
  guestSign: "Получил (гость)",
  cashCollected: "Получено курьером",
  // Брони, клиенты, услуги
  reservationsTitle: "Брони на {{date}}",
  customerCard: "Карточка клиента",
  balanceAfter: "Остаток долга",
  servicesTitle: "Отчёт по услугам",
  salesBase: "Сумма продаж",
};

export const en: Shape<typeof ru> = {
  receipt: "Receipt",
  waiter: "Waiter",
  tip: "Tip",
  change: "Change",
  refund: "Refund",
  netPaid: "Total paid",
  count: "Count",
  dateTime: "Date and time",
  indicator: "Metric",
  value: "Value",
  method: "Payment method",
  share: "Share",
  operation: "Operation",
  kind: "Type",
  tags: "Tags",
  manager: "Manager",
  summary: "Summary",
  byMethod: "By payment method",
  ordersTitle: "Order log",
  opNo: "Operation No. {{n}}",
  basis: "Reason",
  handedIn: "Handed in by",
  received: "Received by",
  issued: "Issued by",
  incoming: "In",
  outgoing: "Out",
  incomingOrder: "Cash receipt voucher",
  outgoingOrder: "Cash disbursement voucher",
  shiftOpsTitle: "Shift cash operations",
  slip80: "Slip (80 mm)",
  cashOrderA4: "Cash voucher (A4)",
  financeTitle: "Financial report",
  pnl: "Profit and loss",
  foodCostPct: "Food cost, %",
  laborCostPct: "Labor cost to revenue, %",
  marginPct: "Margin, %",
  supplierCredit: "Purchases on supplier credit",
  creditSales: "Sales on credit",
  debtRepayments: "Debt repayments",
  expenseCategory: "Expense category",
  purchasedSum: "Purchased amount",
  writtenOffSum: "Written-off amount",
  writeoffsTitle: "Write-offs",
  cancelledOrders: "Cancelled orders",
  voidedLines: "Removed items",
  courierSlip: "Delivery slip",
  deliveryFee: "Delivery",
  guestSign: "Received (guest)",
  cashCollected: "Collected by courier",
  reservationsTitle: "Reservations for {{date}}",
  customerCard: "Customer card",
  balanceAfter: "Debt balance",
  servicesTitle: "Services report",
  salesBase: "Sales amount",
};

export const ky: Shape<typeof ru> = {
  receipt: "Чек",
  waiter: "Официант",
  tip: "Чайпул",
  change: "Кайтарым",
  refund: "Кайтаруу",
  netPaid: "Бардыгы төлөндү",
  count: "Саны",
  dateTime: "Күнү жана убактысы",
  indicator: "Көрсөткүч",
  value: "Мааниси",
  method: "Төлөө ыкмасы",
  share: "Үлүшү",
  operation: "Операция",
  kind: "Түрү",
  tags: "Тегдер",
  manager: "Башкаруучу",
  summary: "Жыйынтыктар",
  byMethod: "Төлөө ыкмалары боюнча",
  ordersTitle: "Буйрутмалар журналы",
  opNo: "Операция № {{n}}",
  basis: "Негиз",
  handedIn: "Тапшырды",
  received: "Алды",
  issued: "Берди",
  incoming: "Кириш",
  outgoing: "Чыгаша",
  incomingOrder: "Кирешелик касса ордери",
  outgoingOrder: "Чыгашалык касса ордери",
  shiftOpsTitle: "Сменанын касса операциялары",
  slip80: "Квитанция (80 мм)",
  cashOrderA4: "Касса ордери (A4)",
  financeTitle: "Финансылык отчёт",
  pnl: "Пайда жана чыгым",
  foodCostPct: "Food cost, %",
  laborCostPct: "Эмгек акы фонду кирешеге, %",
  marginPct: "Маржа, %",
  supplierCredit: "Жеткирүүчүлөрдөн карызга сатып алуулар",
  creditSales: "Карызга сатуулар",
  debtRepayments: "Карыз төлөмдөрү",
  expenseCategory: "Чыгаша беренеси",
  purchasedSum: "Сатып алынган сумма",
  writtenOffSum: "Эсептен чыгарылган сумма",
  writeoffsTitle: "Эсептен чыгаруулар",
  cancelledOrders: "Жокко чыгарылган буйрутмалар",
  voidedLines: "Өчүрүлгөн позициялар",
  courierSlip: "Маршрут баракчасы",
  deliveryFee: "Жеткирүү",
  guestSign: "Алды (конок)",
  cashCollected: "Курьер алды",
  reservationsTitle: "{{date}} күнкү броньдор",
  customerCard: "Кардардын картасы",
  balanceAfter: "Карыздын калдыгы",
  servicesTitle: "Кызматтар боюнча отчёт",
  salesBase: "Сатуулардын суммасы",
};

export const uz: Shape<typeof ru> = {
  receipt: "Chek",
  waiter: "Ofitsiant",
  tip: "Choychaqa",
  change: "Qaytim",
  refund: "Qaytarish",
  netPaid: "Jami to'langan",
  count: "Soni",
  dateTime: "Sana va vaqt",
  indicator: "Ko'rsatkich",
  value: "Qiymat",
  method: "To'lov usuli",
  share: "Ulush",
  operation: "Operatsiya",
  kind: "Turi",
  tags: "Teglar",
  manager: "Boshqaruvchi",
  summary: "Yakunlar",
  byMethod: "To'lov usullari bo'yicha",
  ordersTitle: "Buyurtmalar jurnali",
  opNo: "Operatsiya № {{n}}",
  basis: "Asos",
  handedIn: "Topshirdi",
  received: "Qabul qildi",
  issued: "Berdi",
  incoming: "Kirim",
  outgoing: "Chiqim",
  incomingOrder: "Kirim kassa orderi",
  outgoingOrder: "Chiqim kassa orderi",
  shiftOpsTitle: "Smenaning kassa operatsiyalari",
  slip80: "Kvitansiya (80 mm)",
  cashOrderA4: "Kassa orderi (A4)",
  financeTitle: "Moliyaviy hisobot",
  pnl: "Foyda va zarar",
  foodCostPct: "Food cost, %",
  laborCostPct: "Ish haqi fondi tushumga nisbatan, %",
  marginPct: "Marja, %",
  supplierCredit: "Yetkazib beruvchilardan qarzga xaridlar",
  creditSales: "Qarzga sotuvlar",
  debtRepayments: "Qarz to'lovlari",
  expenseCategory: "Xarajat moddasi",
  purchasedSum: "Xarid summasi",
  writtenOffSum: "Hisobdan chiqarilgan summa",
  writeoffsTitle: "Hisobdan chiqarishlar",
  cancelledOrders: "Bekor qilingan buyurtmalar",
  voidedLines: "O'chirilgan pozitsiyalar",
  courierSlip: "Yo'nalish varaqasi",
  deliveryFee: "Yetkazib berish",
  guestSign: "Qabul qildi (mehmon)",
  cashCollected: "Kuryer oldi",
  reservationsTitle: "{{date}} uchun bronlar",
  customerCard: "Mijoz kartasi",
  balanceAfter: "Qarz qoldig'i",
  servicesTitle: "Xizmatlar bo'yicha hisobot",
  salesBase: "Sotuvlar summasi",
};
